import * as React from 'react';

import { ProfileDocumentFragment, TravellerProfileFragment } from '@websky/graphql';
import { ButtonBase } from '@mui/material';

import { useTheme } from '../../../../theme';
import { useIsMobile } from '../../../../utils';
import { DocumentInfoCard } from '../../../../InfoCard/types';
import { InputVariant } from '../../../../BaseComponents/Input/types';
import { CdnIcon } from '@shared/ui';
import DocumentFormFields from '../DocumentFormFields/DocumentFormFields';

interface Props {
	id: number;
	traveller: TravellerProfileFragment;
	document?: DocumentInfoCard;
	primaryCountryCodes?: string[];
	validators?: ProfileDocumentFragment;
	onRemove?: (id: number) => void;
	onClear?: (id: number) => void;
}

const DocumentFieldsItem: React.FC<Props> = ({ id, traveller, primaryCountryCodes, validators, onRemove, onClear }) => {
	const { DocumentFieldsItem: css } = useTheme('TravellerForm');

	const isMobile = useIsMobile();

	const variant: InputVariant = isMobile ? 'underline' : 'labelIn';

	return (
		<div className={css.documentFieldsItem}>
			<DocumentFormFields
				index={id}
				validators={validators}
				traveller={traveller}
				primaryCountryCodes={primaryCountryCodes}
				variant={variant}
				layout={isMobile ? 'stack' : 'grid'}
			/>

			{(onRemove || onClear) && (
				<div className={css.documentFieldsItem__controls}>
					<ButtonBase
						classes={{ root: css.buttonRemove }}
						onClick={() => (onRemove ? onRemove(id) : onClear?.(id))}
					>
						<CdnIcon icon={'Action/Close-Clear'} />
					</ButtonBase>
				</div>
			)}
		</div>
	);
};

export default DocumentFieldsItem;
